import { BaseDto } from './base.dto';

export class DatesDto extends BaseDto {
    date_key: Date;
    calendarYear: number;
    calendarQuarter: number;
    calendarMonthNo: number;
    calendarWeekNo: number;
    dayNumberOfMonth: number;
    dayNumberOfWeek: number;
    closed: boolean;
    label: string;
    actualDate: Date;
}
